import axios from "axios";
import { ApiConfiguration } from "./ApiConfiguration";

export const apiClient = axios.create({
  baseURL: ApiConfiguration.baseUrl,
  timeout: ApiConfiguration.timeout,
  headers: {
    // "Content-Type": "application/json",
    Accept: "application/json",
  },
});
